import { render } from "./CatchLine.vue?vue&type=template&id=36381606"
import script from "./CatchLine.vue?vue&type=script&lang=js"
export * from "./CatchLine.vue?vue&type=script&lang=js"

import "./CatchLine.vue?vue&type=style&index=0&id=36381606&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__